import React, { useRef } from 'react';
import Slider, { Settings } from 'react-slick';
import { Button } from 'antd';

import { ITeamMember } from '../interfaces';
import { BaseModal, BaseModalFooter } from 'shared/wrappers/BaseModal';

import styles from './MemberPreviewModal.module.scss';

type Props = {
  slideIndex: number;
  onClose: () => void;
  teamMembers: ITeamMember[];
};

const sliderSettings: Settings = {
  dots: false,
  infinite: true,
  autoplay: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  touchMove: false,
};

export default function MemberPreviewModal(props: Props) {
  const { teamMembers, onClose, slideIndex } = props;
  const sliderRef: any = useRef();

  const handlePreviousClick = () => {
    sliderRef.current.slickPrev();
  };

  const handleNextClick = () => {
    sliderRef.current.slickNext();
  };

  return (
    <BaseModal title="" onCancel={onClose} className={styles.modal}>
      <div className={styles.header}></div>
      <div className="modal-scroll-wrapper">
        <Slider ref={sliderRef} {...sliderSettings} initialSlide={slideIndex}>
          {teamMembers.map((member, index) => (
            <div className="slider-item" key={index}>
              <div className={styles.content}>
                <div className={styles.avatar}>
                  <img src={member.avatar} alt={`${member.name} avatar`} />
                </div>
                <div className={styles.textBox}>
                  <div className={styles.title}>{member.name}</div>
                  <div className={styles.text}>{member.bio}</div>
                  <ul className={styles.social}>
                    <li>
                      <a href={member.linkedInLink} target="blank">
                        <span className="icon icon-linkedin-circle" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <BaseModalFooter className="button-space-between">
        <Button onClick={handlePreviousClick}>Previous</Button>

        <Button onClick={handleNextClick}>Next</Button>
      </BaseModalFooter>
    </BaseModal>
  );
}
